import { keyBy, mapValues } from 'lodash';
import { useMemo } from 'react';

import routingGroupsResource from 'src/actions/routingGroups/routingGroupsResource';
import { useResourceValues } from 'src/presentation/hooks/useResource';

const useInboxes = () => {
  const { values: inboxes = [] } = useResourceValues(routingGroupsResource);

  const inboxesMap = useMemo(() => mapValues(keyBy(inboxes, 'id')), [inboxes]);

  const inboxesOptions = useMemo(
    () => inboxes.filter(inbox => !inbox.disabled).map(inbox => ({ label: inbox.name, value: inbox.id })),
    [inboxes]
  );

  return { inboxesMap, inboxesOptions };
};

export default useInboxes;
